import React from "react";
import ReactDOM from "react-dom/client";

import App from "./app/App";
import "./index.css";
import { applyTheme, loadThemeFromLocalStorage } from "./utils/themeUtils";
import { installAuthFailureGuard } from "./services/authFailureGuard";

applyTheme(loadThemeFromLocalStorage());
installAuthFailureGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
